<div class="punchlist-settings">
  <div class="action-section flex flex-row-reverse my-[20px] w-full gap-[20px]">
    <app-primary-button (handleClick)="createPunchlist()" class="!w-[150px]">Create</app-primary-button>
  </div>

  <div class="list-section">
    @if (punchlists?.length) {
      <div class="punchlist-list-table">
        <table [dataSource]="punchlists" class="mat-elevation-z8 table" mat-table>
          <ng-container matColumnDef="name">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Name</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-8">{{ row?.name }}</div>
              <div class="description text-type-14">{{ row?.description }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Status</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div [ngClass]="statusMap[row?.status]?.textColor || ''" class="status-text text-type-11">
                {{ statusMap[row?.status]?.label || (row?.status | titlecase) }}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="start_date">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Start Date</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.start_date ? (row.start_date | date:'MMM d, y') : '—' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="completion_date">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Completion Date</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.completion_date ? (row.completion_date | date:'MMM d, y') : '—' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="substantial_completion">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Substantial Completion</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.substantial_completion ? 'Yes' : 'No' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="prime_contractor">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Prime Contractor</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.primeContractor?.name || '—' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="created_at">
            <th *matHeaderCellDef mat-header-cell>
              <span class="th-text">Created</span>
            </th>
            <td *matCellDef="let row" mat-cell>
              <div class="text-type-11">{{ row?.created_at | date:'MMM d, y' }}</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th *matHeaderCellDef mat-header-cell class="actions-col"></th>
            <td *matCellDef="let row" mat-cell class="actions-col">
              <button [matMenuTriggerFor]="punchlistMenu"
                      (click)="$event.stopPropagation()"
                      class="more-menu-button"
                      aria-label="More options">
                <mat-icon>more_horiz</mat-icon>
              </button>
              <mat-menu #punchlistMenu="matMenu">
                <button mat-menu-item (click)="downloadPdf(row)">
                  <mat-icon>picture_as_pdf</mat-icon>
                  <span>PDF Report</span>
                </button>
                <button mat-menu-item (click)="downloadCsv(row)">
                  <mat-icon>table_chart</mat-icon>
                  <span>CSV Export</span>
                </button>
                <button mat-menu-item (click)="downloadKmz(row)">
                  <mat-icon>map</mat-icon>
                  <span>KMZ Map File</span>
                </button>
                <button mat-menu-item (click)="sendAllToContractor(row)">
                  <mat-icon>send</mat-icon>
                  <span>Forward all items to contractor</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
          <tr
            (click)="rowClicked(row)"
            *matRowDef="let row; columns: displayedColumns"
            [class.highlighted-row]="row === selectedRow"
            class="cursor-pointer"
            mat-row
          ></tr>
        </table>
      </div>
    } @else {
      <div class="no-data text-type-8 mt-[80px]">No punch lists configured for this project.</div>
    }
  </div>
</div>
